import React from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import { t } from "i18next";
import { appLicensesSourceAtom } from "../pages/lincenses.store";
import { useRecoilValue } from "recoil";
import { toast } from "react-toastify";
import { useStatus } from "hooks/use-status";
import { callAll } from "helpers/misc";
import { useServerErrors } from "hooks/use-server-errors";
import { Button, Form, InputField, SelectField } from "components/form";
import { useParams } from "react-router-dom";
import { useReasonsDevices } from "hooks/use-products";

const ChangeDevice = ({ show, onHide, device, ...props }) => {
  const { isLoading, load, done, stop } = useStatus();
  const [serverErrors, setServerErrors] = useServerErrors();
  const { id, deviceName } = device;
  const {id:versionSubscriptionId} = useParams()
  const  {reasonsChanges}=useReasonsDevices()
  const appLicensesSource = useRecoilValue(appLicensesSourceAtom(versionSubscriptionId));
  const success = () => {
    done();
    appLicensesSource.reload();
    onHide();
    toast.success(t("common:form.updated"));
  };

  const handleRequest = (data) => {
    const changeDevice = {
      versionSubscriptionId: versionSubscriptionId,
      deviceName: data?.newDevice,
      serialNumber: data?.serialNumber,
      deviceId: id,
      reasonChangeId: data?.reasonChangeId
    }
    appLicensesSource
      .store()
      .update(changeDevice)
      .then(success)
      .catch(callAll(stop, setServerErrors));
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
        className="all-modal changeNumber"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{t("browse-apps:myProducts.productLicense.changeDevice")}</h1>
          </div>
          <Form
            className="row"
            onSubmit={handleRequest}
            defaultValues={{
              deviceName: deviceName,
              newDevice: "",
              serialNumber: "",
              reasonChangeId:""
            }}
          >
            {({ watch }) => {
              return (
                <>
                  <div className="col-md-12">
                    <InputField label={t("browse-apps:myProducts.productLicense.deviceCol")} id="deviceName" readonly />
                  </div>
                  <div className="col-md-12">
                    <InputField
                      label={t("browse-apps:myProducts.productLicense.newDevice")}
                      id="newDevice"
                      rules={{ required: "errors:required" }}
                    />
                  </div>
                  <div className="col-md-12">
                    <InputField
                      label={t("browse-apps:myProducts.productLicense.newSerial")}
                      serverError={serverErrors?.serialNumber}
                      id="serialNumber"
                      rules={{ required: "errors:required" }}
                    />
                  </div>
                  <div className="col-md-12">
                    <SelectField
                      labelField="reason"
                      label={t("browse-apps:myProducts.productLicense.reasonChange")}
                      id="reasonChangeId"
                      rules={{ required: "errors:required" }}
                      options={reasonsChanges}
                    />
                  </div>


                  <div className="col-12">
                    <Button type="submit" className="btn-blue mt-4" isLoading={isLoading}>
                      {t("browse-apps:myProducts.productLicense.submit")}
                    </Button>
                  </div>
                </>
              );
            }}
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChangeDevice;
